/**
 * Perform module setup for mobile search toggle
 */
export default function setupMobileSearch() {
	setTimeout(() => {
		const headerTop: HTMLElement = document.getElementById('roc-header-search') as HTMLElement;
		const trigger: HTMLElement = document.getElementById('roc-header-search-btn-mobile') as HTMLElement;
		const triggerTwo: HTMLElement = document.getElementById('roc-header-search-toggle') as HTMLElement;
		const searchInput: HTMLElement = document.getElementById('global-search-text-input') as HTMLElement;

		let open = false;

		if (!triggerTwo || !headerTop || !trigger) {
			return;
		}

		const handleOpen = () => {
			headerTop.classList.add('roc-header__search--show');

			if (searchInput) {
				searchInput.focus();
			}

			open = true;
		};

		const handleClose = () => {
			headerTop.classList.remove('roc-header__search--show');
			open = false;
		};

		const handleToggle = () => {
			if (open) {
				handleClose();
			} else {
				handleOpen();
			}
		};

		window.onclick = (e) => {
			if (e.target !== headerTop && !headerTop.contains(e.target) && !trigger.contains(e.target)) {
				handleClose();
			}
		};

		trigger.onclick = () => handleToggle();
		triggerTwo.onclick = () => handleToggle();
	}, 750);
}
